module.exports = __webpack_public_path__ + "static/img/仓库2@2x.d084c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/仓库2@2x.png
// module id = StsI
// module chunks = 1